import { render, staticRenderFns } from "./FormChooseMultipleProductInputAnswer.vue?vue&type=template&id=55150701&scoped=true"
import script from "./FormChooseMultipleProductInputAnswer.vue?vue&type=script&lang=js"
export * from "./FormChooseMultipleProductInputAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55150701",
  null
  
)

export default component.exports